var _defs, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37.158mm",
    height: "37.158mm",
    viewBox: "0 0 37.158 37.158",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1962"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m118.74 93.923 15.368 3.2403 0.78694 23.099s-11.387 4.5365-11.804 4.3513c-0.41661-0.18516-5.2308-3.3329-5.2308-3.3329v-27.034z",
    fill: "none",
    stroke: "#000",
    strokeWidth: ".26458px"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-112.93 -85.158)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.51,
    cy: 103.74,
    rx: 18.579,
    ry: 18.579,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.2676 -4.6291)",
    clipPath: "url(#clipPath1962)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.72,
    cy: 108.39,
    r: 12.682,
    fill: "#ffcead",
    opacity: 0.67347,
    style: {
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.19,
    cy: 108.39,
    rx: 9.3845,
    ry: 12.682,
    fill: "#ffb07b",
    opacity: 0.55952,
    style: {
      paintOrder: "stroke fill markers"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df59311758866f90234a4282798a56b9.svg";
export { ForwardRef as ReactComponent };